var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgJumpingSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#E1087E"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M15 9.825L13.125 11.7c-.2.183-.438.28-.712.288a.93.93 0 01-.713-.288c-.2-.2-.3-.433-.3-.7a.96.96 0 01.3-.7l3.6-3.6a.877.877 0 01.325-.213A1.107 1.107 0 0116 6.425c.133 0 .258.02.375.063a.877.877 0 01.325.212l3.6 3.6c.2.2.3.433.3.7 0 .267-.1.5-.3.7-.2.2-.438.3-.713.3a.974.974 0 01-.712-.3L17 9.825v12.35l1.875-1.875a1.07 1.07 0 01.713-.288.93.93 0 01.712.288c.2.2.3.433.3.7 0 .267-.1.5-.3.7l-3.6 3.6c-.1.1-.208.17-.325.212-.117.042-.242.063-.375.063s-.258-.02-.375-.063a.877.877 0 01-.325-.212l-3.6-3.6c-.2-.2-.3-.433-.3-.7a.96.96 0 01.3-.7c.2-.2.438-.3.713-.3.274 0 .512.1.712.3L15 22.175V9.825z"
  }))));
}
export default SvgJumpingSelected;